module.exports = __webpack_public_path__ + "img/jcp-logo.e656beae.svg";